import React from 'react'
import { motion } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

export function DraggableSpringBack({ values = {} }: { values?: FieldValues }) {
  const dragElastic = values.dragElastic ?? 0.6
  const dragScale = values.dragScale ?? 1.1
  const stiffness = values.stiffness ?? 300
  const damping = values.damping ?? 20

  return (
    <div className="flex items-center justify-center h-full">
      <motion.div
        drag
        dragConstraints={{ top: 0, bottom: 0, left: 0, right: 0 }}
        dragElastic={dragElastic}
        whileDrag={{ scale: dragScale }}
        transition={{ type: 'spring', stiffness, damping }}
        className="w-16 h-16 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-2xl shadow-lg cursor-grab active:cursor-grabbing flex items-center justify-center"
      >
        <span className="text-white text-[10px] font-semibold pointer-events-none">Drag</span>
      </motion.div>
    </div>
  )
}
